import { render, staticRenderFns } from "./store-merchant.vue?vue&type=template&id=7bc8f4b8"
import script from "./store-merchant.vue?vue&type=script&lang=ts"
export * from "./store-merchant.vue?vue&type=script&lang=ts"
import style0 from "./store-merchant.vue?vue&type=style&index=0&id=7bc8f4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports